import { render, staticRenderFns } from "./WorkPowerViz.vue?vue&type=template&id=f67aa8a4&scoped=true"
import script from "./WorkPowerViz.vue?vue&type=script&lang=js"
export * from "./WorkPowerViz.vue?vue&type=script&lang=js"
import style0 from "./WorkPowerViz.vue?vue&type=style&index=0&id=f67aa8a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67aa8a4",
  null
  
)

export default component.exports